import { serviceO as axiosIns } from '../utils/axios';
export const headerForm = {
    'content-type': 'application/x-www-form-urlencoded'
};

export const headerJson = {
    'content-type': 'application/json'
};

/**
 * 测评记录
 * @param {*} data
 */
export function evalRecordList(data,params) {
    return axiosIns({
        url: `ncdpSurvey/answerAndResult/queryAppSurveyAnswerList`,
        method: 'post',
        data,
        params
    })
}

/**
 * 测评详情
 */
export function evalRecordDetail(data) {
    return axiosIns({
        url: `survey/score/getSurveyResultBySurvey/${data.surveyId}/${data.id}`,
        method: 'GET',
        data
    })
}

/**
 * 量表详情
 * @param {appSurveyId} data
 */
export function getAppSurveyDetail(data) {
    return axiosIns({
        url: `ncdpSurvey/appSurvey/getAppSurveyDetailById/${data.appSurveyId}`,
        // url: `ncdpSurvey/appSurvey/getAppSurveyDetailForApp/${data.appSurveyId}`,
        method: 'GET'
    })
}

/**
 * 我的测评-查看测评结果
 * @param {memberCode, appSurveyAnswerId} data
 */
export function appSurveyResult(data) {
    return axiosIns({
        url: `ncdpSurvey/answerAndResult/queryAppSurveyAnswerDetail/${data.memberCode}/${data.appSurveyAnswerId}`,
        method: 'GET',
        // data: {
        //     ...data
        // }
    })
}

/**
 * 重新测评
 * @param {*} data
 * @param {*} params
 */
export function restartAppSurvey(params){
    return axiosIns({
        url: `ncdpSurvey/answerAndResult/restartAppSurvey/${params.memberCode}/${params.appSurveyId}/${params.appSurveyAnswerId}`,
        method: 'GET',
        params
    })
}

/**
 * 开始测评前来生成：appSurveyAnswerId
 * @param {*} data
 */
export function startAppSurvey(params){
    return axiosIns({
        url:`ncdpSurvey/answerAndResult/startAppSurvey/${params.memberCode}/${params.appSurveyId}`,
        method: 'GET',
        params
    })
}

/**
 * 提交测评
 * @param {} data
 * @param {*} params
 */
export function submitAnswer(data) {
    return axiosIns({
        url: `ncdpSurvey/answerAndResult/submitAnswer`,
        method: 'POST',
        data
    })
}

/**
 * 测评，获取题目
 */
export function getQuestionsAPI(data){
    return axiosIns({
        url: `ncdpSurvey/survey/getSurveyDetailBySurveyId/${data.surveyId}`,
        method: 'GET'
    })
}


/**
 * 通过memberId获取会员信息
 * @param {memberCode} data
 */
export function getPersonalInfoByMemberId(data){
    return axiosIns({
        url: 'api/getMemberInfo',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/evalRecord.js